import { render, staticRenderFns } from "./ManufacturerEdit.vue?vue&type=template&id=249e619b&"
import script from "./ManufacturerEdit.vue?vue&type=script&lang=js&"
export * from "./ManufacturerEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports